import React from 'react';

// Material UI Components
import {Button} from '@material-ui/core';

export default function FontSize( {StyleButton, currentSelectionOffset, contentBlock, onClickToggleStyle} ) {
    const fontSizes = ["14", "16", "24", "32", "40", "64", "96"];
    const stylesArray = [...contentBlock.getInlineStyleAt(currentSelectionOffset)]

    let [fontSizeActive, setFontSizeActive] = React.useState('14');

    React.useEffect(() => {
        fontSizes.forEach(font => {
            const fontSize = stylesArray.find(style => style === font) || "";
    
            if(fontSize === "14"){
                setFontSizeActive("14")
            }
            if(fontSize === "16"){
                setFontSizeActive("16")
            }
            if(fontSize === "24"){
                setFontSizeActive("24")
            }
            if(fontSize === "32"){    
                setFontSizeActive("32")    
            } 
            if(fontSize === "40"){     
                setFontSizeActive("40")      
            } 
            if(fontSize === "64"){ 
                setFontSizeActive("64")
            }
            if(fontSize === "96"){
                setFontSizeActive("96")
            }
        });
    }, [fontSizes, stylesArray])

    return (
        <React.Fragment>
            {
                fontSizes.map((item, index) => {
                    return(
                        <div key={index} onMouseDown={(event) => {
                            event.preventDefault();
                            onClickToggleStyle(item)
            
                        }}>
                            <Button 
                                aria-label={`font size ${item}px`} 
                                className={StyleButton} 
                                color={(fontSizeActive === item) ? "primary" : "inherit"} 
                                size="small"
                                style={{minWidth: "34px", margin: "0"}}
                                variant={(fontSizeActive === item) ? "contained" : "text"}>
                                {item}
                            </Button  >
                        </div>
                    );
                })
            }
        </React.Fragment>
    )
}